var createFocusTrap = require('../../../../node_modules/focus-trap/dist/focus-trap.js');

var searchModal = document.querySelector('.search-modal');

var seaerchFocusTrap = createFocusTrap('.search-modal', {
  onDeactivate: function () {
    searchModal.className = 'search-modal trap';
  },
});

document.querySelector('.search-icon').addEventListener('click', function () {
  seaerchFocusTrap.activate();
  searchModal.className = 'trap search-modal open-search is-active';
});

document.querySelector('.close-search').addEventListener('click', function () {
  seaerchFocusTrap.deactivate();
});

